import React from 'react'

import { Header } from 'presentation/shared/components/Header'
import { Container } from 'presentation/shared/components/Container'
import BottomMenu from 'presentation/shared/components/BottomMenu'
import { UpdateLifeHabits } from 'domain/usecases/patient/update-life-habits'
import LifeHabitsForm from 'presentation/patient/components/Forms/LifeHabits'

type Props = {
  updateLifeHabits?: UpdateLifeHabits
}

export default function LifeHabitsLayout({ updateLifeHabits }: Props) {
  return (
    <>
      <Header />
      <Container hasHeader>
        <LifeHabitsForm updateLifeHabits={updateLifeHabits} />
      </Container>
      <BottomMenu />
    </>
  )
}
